export var NOTIFICATIONS_INDENT = 8;